/**
 * StatusBadge — kleurgecodeerde statuspil.
 * variants: ok | warn | err | info | neutral
 */
const VARIANTS = {
  ok:      'bg-emerald-500/15 text-emerald-300 border-emerald-400/30',
  warn:    'bg-amber-500/15 text-amber-300 border-amber-400/30',
  err:     'bg-rose-500/15 text-rose-300 border-rose-400/30',
  info:    'bg-sky-500/15 text-sky-300 border-sky-400/30',
  neutral: 'bg-white/8 text-white/70 border-white/15',
};

export default function StatusBadge({ children, variant = 'neutral', testId, className = '' }) {
  const cls = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10.5px] font-medium uppercase tracking-wider ${cls} ${className}`}
      data-testid={testId}
    >
      {children}
    </span>
  );
}
